/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, ReactNode } from 'react';
import { styled, TableCellProps, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import MuiTableCell, { tableCellClasses } from '@mui/material/TableCell';

interface ICustomCustomTableCellprops extends TableCellProps {
  sx?: SxProps<Theme>;
  children: ReactNode;
  height?: number;
  customStyles?: any;
}

const TableCell = styled(MuiTableCell, {
  shouldForwardProp: prop => prop !== 'customStyles',
})<ICustomCustomTableCellprops>(({ theme, customStyles }) => ({
  fontSize: '0.875rem',
  padding: 12,
  borderColor: theme.palette.divider,
  head: {
    fontWeight: 600,
    paddingTop: 20,
    paddingBottom: 20,
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.mind.custom.tableHead,
  },
  ...(customStyles || {}),
}));

function CustomTableCell({ children, height = 65, customStyles, ...props }: ICustomCustomTableCellprops) {
  return (
    <TableCell {...props} customStyles={customStyles} sx={{ ...props.sx, height }}>
      {children}
    </TableCell>
  );
}

export default memo(CustomTableCell);
